module.exports = __webpack_public_path__ + "static/media/IconoPila3.7ec6cc9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/gbadicionales/IconoPila3.svg
// module id = 758
// module chunks = 0